import i18next from 'i18next';
import { isEmpty } from 'lodash';
import * as Yup from 'yup';

export interface RangeObject<T = number> {
  min: T;
  max: T;
}

const validateRanges = <T>(ranges: RangeObject<T>[] = []) => {
  if (isEmpty(ranges)) {
    return true;
  }
  const sortedRanges = [...ranges].sort((a, b) =>
    a.min < b.min ? -1 : a.min > b.min ? 1 : 0,
  );
  return !sortedRanges.some(
    (range, index) => index > 0 && range.min < sortedRanges[index - 1].max,
  );
};

const validateMinLessMax = <T>(ranges: RangeObject<T>[] = []) =>
  !ranges.some((range) => range.max <= range.min);

export const INTERVAL_COMMISSION_VALIDATION_SCHEMA = Yup.array()
  .of(
    Yup.object().shape({
      min: Yup.number()
        .min(0, i18next.t('errors.percentage'))
        .required(i18next.t('errors.required')),
      max: Yup.number()
        .min(0, i18next.t('errors.percentage'))
        .required(i18next.t('errors.required')),
      commission: Yup.number()
        .min(0, i18next.t('errors.percentage'))
        .lessThan(100, i18next.t('errors.percentage'))
        .required(i18next.t('errors.required')),
    }),
  )
  .test(
    'no-overlap',
    i18next.t('features.commission.intervalOverlay'),
    validateRanges,
  )
  .test(
    'min-less-max',
    i18next.t('features.commission.minLessMaxError'),
    validateMinLessMax,
  );

export { validateRanges, validateMinLessMax };
